<template>
    <div class="single-choice item-list" :class="{'inline': !config.vertical}">
        <draggable :list="items" :disabled="!editable" @change="onChange">
            <div v-for="(item, index) in items" :key="index" class="item tw-group/rank tw-mb-2"
                 @click="selectOption(item)" :class="{'selected': selected.includes(item)}">
                <label class="choice" :style="{
                            ...inputStyles,
                            borderColor: inputStyles.color,
                            backgroundColor: convertHexToRGBA(inputStyles.color, 10)
                        }">
                    <span class="checkbox" :style="{ borderColor: inputStyles.color }"></span>
                    <survey-page-editable :target="item" :editable="editable" placeholder="Option" @changed="onEditableChange($event,index)" />
                </label>
                <span v-if="editable" class="remove tw-hidden group-hover/rank:tw-inline-block" @click="deleteChoice(index)"></span>
            </div>
        </draggable>
        <div class="item tw-group/rank tw-mb-2" v-if="config.other_option" @click="selectOption('custom-value')" :class="{'selected': selected.includes('custom-value')}">
            <label class="choice" :style="{
                            ...inputStyles,
                            borderColor: inputStyles.color,
                            backgroundColor: convertHexToRGBA(inputStyles.color, 10)
                        }">
                <span class="checkbox" :style="{ borderColor: inputStyles.color }"></span>
                <survey-page-editable :target="custom" :editable="true" :untouchable="editable" placeholder="Other" @changed="onEditableChange($event,'custom')" />
            </label>
        </div>

        <div v-if="editable" class="add-choice" :style="{color: inputStyles.color}" @click="addChoice">Add Choice</div>
    </div>
</template>

<script>
import draggable from "vuedraggable";
import SurveyPageEditable from "@/pages/surveys/SurveyPageEditable.vue";

export default {
    name: 'QuestionSingleChoice',
    components: {SurveyPageEditable, draggable},
    props: {
        value: {
            type: Array,
            default: () => [],
        },
        inputStyles: {
            type: Object,
            default: () => {},
        },
        readonly: {
            type: Boolean,
            default: false
        },
        editable: {
            type: Boolean,
            default: false
        },
        config: {
            type: Object,
            required: true
        },
    },
    data() {
        return {
            items: [],
            selected: [],
            custom: '',
        }
    },
    computed: {
        shouldShowOther() {
            return this.config.other_option && this.selected === 'other'
        },
    },
    watch: {
        value: {
            immediate: true,
            handler: 'setSelected',
        },
        'config.options'() {
            this.resetOptions();
        },
    },
    methods: {
        selectOption(value) {
            if (this.editable) return;
            if (this.selected.includes(value)) this.selected.splice(this.selected.indexOf(value), 1);
            else this.selected.push(value);
            this.onChange();
        },
        setSelected() {
            if (this.value && this.value.length) {
                this.resetOptions();
                this.selected = this.items.filter(value => this.value.includes(value));
            } else this.selected = [];
            this.onChange();
        },
        onEditableChange(item,index) {
            if (index === 'custom') {
                this.custom = item;
            } else this.items[index] = item;
            this.onChange();
        },
        onChange() {
            if (!this.readonly) {
                let _selected = [...this.selected];
                if (_selected.includes('custom-value')) {
                    _selected.splice(this.selected.indexOf('custom-value'), 1);
                    _selected.push(this.custom);
                }
                this.$emit('answer', {value: _selected, valid: true});
            }
            if (this.editable) this.$emit('config', {options: this.items});
        },
        addChoice() {
            if (!this.editable) return;
            this.items.push('');
            this.$emit('config', {options: this.items});
        },
        deleteChoice(index) {
            this.items.splice(index,1);
            this.$emit('config', {options: this.items});
        },
        resetOptions() {
            this.items = this.config.options;
            if (!this.items) this.items = [];
        }
    },
    mounted() {
        this.resetOptions();
    }
}
</script>
